import { useAuth } from '@/hooks/useAuth';
import {
  type PlanFeature,
  planHasFeature,
  getPlanFeatures,
  getTrialDaysRemaining,
  isTrialExpired,
  TRIAL_DURATION_DAYS,
  TRIAL_LIMITS,
} from '@/hooks/planAccess';

export function usePlanAccess() {
  const { profile } = useAuth();

  const plan = profile?.plan || 'trial';
  const isAdmin = profile?.role === 'admin';
  const createdAt = profile?.created_at;

  const trialDaysRemaining = getTrialDaysRemaining(plan, createdAt);
  const trialExpired = isTrialExpired(plan, createdAt);
  const isTrial = plan === 'trial';

  const hasFeature = (feature: PlanFeature): boolean => {
    if (isAdmin) return true;
    return planHasFeature(plan, feature);
  };

  const features = isAdmin ? [] : getPlanFeatures(plan);

  return {
    plan,
    isAdmin,
    isTrial,
    trialDaysRemaining,
    trialExpired,
    hasFeature,
    features,
    TRIAL_DURATION_DAYS,
    TRIAL_LIMITS,
    messageLimit: profile?.monthly_message_limit || TRIAL_LIMITS.messageLimit,
  };
}